type RouteParams = {
  user_id: number;
  id: number;
};

export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  USERS: '/users',
  PENDING_USERS: '/pending-users',
  USER_SHOW: '/users/:id',
  USER_NEW: '/users/new',
  USER_EDIT: '/users/:id/edit',
  SERVICE_REPORT: '/service-report',
  LOGIN_REPORT: '/login-report',
  ADMINS: {
    INDEX: '/admins',
    NEW: '/admins/new',
    EDIT: '/admins/:id/edit',
  },
  STRESS_ASSESSMENTS: {
    INDEX: '/stress-assessments',
    NEW: '/stress-assessments/new',
    REPORTS: '/stress-assessments/:id/reports',
    REPORTS_DOWNLOAD: '/stress-assessments/:id/reports/download',
    USER_RESULT: '/stress-assessments/:id/users/:user_id/result',
    ROLE_SELECT: '/stress-assessments/role-select',
    SCHEDULE: '/stress-assessments/schedule',
  },
  BRANCHES: {
    INDEX: '/branches',
    NEW: '/branches/new',
    EDIT: '/branches/:id/edit',
  },
  INTERNAL_NEWS: {
    INDEX: '/internal-news',
    NEW: '/internal-news/new',
    EDIT: '/internal-news/:id/edit',
    DETAIL: '/internal-news/:id',
  },
  PORTAL: '/portal',
  CONTRACT_INFO: '/contract-info',
  HOW_TO_USE: 'https://app.fukuri-app.jp/app/client/usage',
  COMPANY_NEWSLETTER_GUIDE: 'https://app.fukuri-app.jp/faq/company-newsletter-guide',
  STRESS_ASSESSMENT_IMPLEMENTER_INQUIRY_FORM: 'https://support.fukuri-app.jp/stresscheck/apply',
  CONTACT: '/contact',
};

export const replaceRouteParams = <K extends keyof RouteParams>(
  route: string,
  params: Record<K, RouteParams[K]>
) => {
  return Object.entries(params).reduce((path, [key, value]) => {
    return path.replace(`:${key}`, String(value));
  }, route);
};
